import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-j', 'LetterJ', [["path",{"d":"M15.25 7v7.5a2.5 2.5 0 0 1-2.5 2.5H11.5A2.5 2.5 0 0 1 9 14.5","key":"svg-0"}]]);